import React from "react";
import JavascriptArraysMethods from "./JavascriptArraysMethods.jsx";
import JavascriptArraysSearch from "./JavascriptArraysSearch.jsx";
import JavascriptArraysSort from "./JavascriptArraysSort.jsx";
import JavascriptArraysIterations from "./JavascriptArraysIterations.jsx";
import JavascriptArraysReference from "./JavascriptArraysReference.jsx";
import JavascriptArraysConst from "./JavascriptArraysConst.jsx";

export default function JsArrays() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Arrays</h1>
      <ul className="mt-4 list-disc ml-6">
        <li>
          <a href="/javascript/arrays/methods" className="underline">
            JS Array Methods
          </a>
        </li>
        <li>
          <a href="/javascript/arrays/search" className="underline">
            JS Array Search
          </a>
        </li>
        <li>
          <a href="/javascript/arrays/sort" className="underline">
            JS Array Sort
          </a>
        </li>
        <li>
          <a href="/javascript/arrays/iterations" className="underline">
            JS Array Iterations
          </a>
        </li>
        <li>
          <a href="/javascript/arrays/reference" className="underline">
            JS Array Reference
          </a>
        </li>
        <li>
          <a href="/javascript/arrays/const" className="underline">
            JS Array Const
          </a>
        </li>
      </ul>
    </div>
  );
}
